
import { CompanyFilters } from "@/utils/company-filters";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>CompanyFilters,
			required: true
		}
	},
	computed: {
		visitedPricingPageItems():ISelectItem<boolean | null>[] {
			return [
				{
					text: "Niet van toepassing",
					value: null
				},
				{
					text: "Nee",
					value: false
				},
				{
					text: "Ja",
					value: true
				}
			];
		}
	}
});

